module.exports = __webpack_public_path__ + "static/media/diagnostic.bbc2c7d4.png";